module.exports = __webpack_public_path__ + "img/klaviyo_logo@2x.15906e08.png";